export default __webpack_public_path__ + "static/media/undraw_Sync_files_re_ws4c.d59383ae.svg";